export default "__VITE_ASSET__4813bd4b__"